export default __webpack_public_path__ + "static/media/ccdbe37e392ae79390ba3d2dbfa1071c.svg";